package no.vareflow.app.domain

enum class InventoryStatus(private val nb: String, private val en: String) {
    DRAFT("Utkast", "Draft"),
    ACTIVE("Aktiv", "Active"),
    CLOSED("Avsluttet", "Closed"),
    ARCHIVED("Arkivert", "Archived");

    val label: String get() = t(nb, en)
    fun labelIn(language: AppLanguage): String = tr(language, nb, en)
}

enum class CategoryWorkStatus(private val nb: String, private val en: String) {
    NOT_STARTED("Ikke startet", "Not started"),
    IN_PROGRESS("Pågår", "In progress"),
    DONE("Ferdig", "Done");

    val label: String get() = t(nb, en)
}

data class InventorySession(
    val id: String = randomId(),
    val companyId: String = DomainDefaults.DEMO_COMPANY_ID,
    val locationId: String,
    val locationName: String,
    val yearMonth: String,
    val status: InventoryStatus = InventoryStatus.DRAFT,
    val createdAt: Long = nowMillis(),
    val closedAt: Long? = null,
    val snapshotVersion: Int = 0
)

data class CategoryAssignment(
    val sessionId: String,
    val category: String,
    val assigneeIds: Set<String> = emptySet(),
    val status: CategoryWorkStatus = CategoryWorkStatus.NOT_STARTED,
    val updatedAt: Long = nowMillis()
)

data class InventoryDepartment(
    val id: String = randomId(),
    val sessionId: String,
    val name: String,
    val sortOrder: Int = 0,
    /** "Hva telles her?": the hovedvarer counted in this department; empty = all hovedvarer. */
    val categories: List<String> = emptyList()
) {
    fun counts(category: String): Boolean = categories.isEmpty() || category in categories
}

data class InventoryCountEntry(
    val sessionId: String,
    val productId: String,
    val departmentId: String = "bar",
    val quantity: Double?,
    val note: String = "",
    val updatedBy: String,
    val updatedAt: Long = nowMillis(),
    val version: Int = 0,
    val lastEventId: String? = null,
    val pendingCloud: Boolean = false
)
